<!-- 选择其他顾客开单 -->
<template>
  <div class="edit white">
    <drawer :title="addEditTitle" :dialogShow="addEditShow" @handleChange="handleChangeDrawer">
      <div slot="body">
        <div class="pay-mains">
          <div class="staffSearch">
            <div class="flex-row">
              <el-input placeholder="请输入手机号/身份证" v-model.trim="mobile" class="input-with-select" clearable></el-input>
              <el-button type="primary" class="ml10" @click="search">搜索</el-button>
            </div>
          </div>
          <div v-if="list.length > 0">
            <div class="staff_box flex-row cur" v-for="(item,index) in list" :key="index" @click="selectMember(item)">
              <div class="box_right ml10">
                <div class="fb">{{item.nickName}}</div>
                <div class="color666 align-items pt16 mb10">
                  <div>手机号码：{{item.mobile}}</div>
                </div>
                <div class="color666 align-items mb10">
                  <div>最近消费：{{formatDate(item.lastTradeTime)}}</div>
                </div>
                <div class="align-items color666 mb10">
                  <div>来源门店：{{item.shopName}}</div>
                </div>
                <div class="align-items color666">
                  <div>可用余额：<span class="jishi">￥{{item.walletAmount}}</span></div>
                </div>
              </div>
            </div>
          </div>
          <div v-else-if="this.isMember && list.length == 0" class="temporarilyNoData">
            <img src="../../../assets/images/new/noMember.png" alt="">
            <p class="mt20 mb20">暂未查询到该会员信息</p>
            <el-button type="primary" @click="addMembered">注册会员</el-button>
            <!-- <div class="color999 fontSize16 mt20" @click="addMembered">注册会员</div> -->
          </div>
          <div v-else class="temporarilyNoData">
            <!-- <img src="../../../assets/images/new/recharge.png" alt=""> -->
            <div class="color999 fontSize16 mt20" @click="addMembered">暂无数据</div>
          </div>
        </div>
      </div>
    </drawer>
    <add-member ref="memberForm" :value="mobile" @handChange='handChanged'></add-member>
  </div>
</template>

<script>
import drawer from "../../../components/common/drawer";
import minxin from "../../../assets/javascript/minxin.js";
import addMember from "../../member/edit.vue";
export default {
  data() {
    return {
      addEditShow: false,
      addEditTitle: "搜索会员",
      list: [],
      mobile: '',
      isMember: false
    };
  },
  mixins: [minxin],
  components: {
    drawer,
    addMember
  },
  created() {
    this.init();
  },
  methods: {
    back() {
      this.addEditShow = false;
      this.list = [];
      this.mobile = "";
      this.isMember = false;
    },
    init() {
      this.$on("set", function(org) {
        Object.assign(this.$data, this.$options.data());
        this.addEditShow = true;
      });
    },
    search () {
      if (!this.mobile) return this.$message.error("请输入内容") 
      this.$api.get(this.$url.member.search, {
        keyword: this.mobile,
        needIntegralFlag: this.integral ? true : false
      })
      .then(res => {
        if (res) {
          this.isMember = true;
          this.list = res.memberList;
        }
      })
      .catch(error => {});
    },
    selectMember (item) {
      this.$emit("change", item);
      this.back();
    },
    handleChangeDrawer(val) {
      this.back();
    },
    addMembered () {
      console.log(1);
      this.$refs.memberForm.$emit("set", true);
    },
    handChanged (org) {
      if (org) {
        this.search(org);
        this.$api.get(this.$url.member.search, {
          keyword: org,
          needIntegralFlag: this.integral ? true : false
        }).then(res => {
          if (res) {
            this.$emit("change", res.memberList[0]);
            this.back();
          }
        }).catch(error => {});
      }
    }
  }
};
</script>
<style scoped lang="less">
@import "../../../assets/css/edit.less";
.demo-drawer__content, .demo-drawer__content > div {
  height: auto;
}
.pay-mains {
  padding: 0;
  // height: 100%;
  .staffSearch {
    padding: 16px;
  }
  /deep/ .el-avatar--large {
    width: 46px;
    height: 46px;
  }
  .infos {
    font-size: 14px;
    color: #F5A623;
  }
  .staff_box {
    // border: 1px solid #fff;
    margin: 0 20px 20px;
    padding: 20px;
    box-shadow: 0 0 10px #ccc;
    border-radius: 4px;
    .box_right {
      flex: 1;
    }
  }
  
}

</style>
